import { BlogPostEditPage } from "@/pages/blog/edit/BlogPostEditPage.tsx";
import { BlogPage } from "@/pages/blog/index/BlogPage.tsx";
import { BlogPostPage } from "@/pages/blog/post/BlogPostPage.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";

export const blogRoutes: RouteConfig[] = [
  {
    path: "/news",
    children: [
      { path: "", element: <BlogPage /> },
      { path: "posts/new", element: <BlogPostEditPage />, isFullScreen: true },
      { path: "posts/:post_id", element: <BlogPostPage /> },
      { path: "posts/:id/edit", element: <BlogPostEditPage />, isFullScreen: true },
      { path: ":channel_id", element: <BlogPage /> },
      { path: ":channel_id/:post_id", element: <BlogPostPage /> },
    ],
  },
];
